import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=064e52e3&scoped=true&"
import script from "./bank.vue?vue&type=script&lang=js&"
export * from "./bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e52e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064e52e3')) {
      api.createRecord('064e52e3', component.options)
    } else {
      api.reload('064e52e3', component.options)
    }
    module.hot.accept("./bank.vue?vue&type=template&id=064e52e3&scoped=true&", function () {
      api.rerender('064e52e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/bank.vue"
export default component.exports